module.exports = __webpack_public_path__ + "img/fondo_index.1bcd890b.jpg";